import { createContext, useContext, type MutableRefObject } from "react";

export const AppMenuContext = createContext<
  | {
      containerRef: MutableRefObject<HTMLDivElement | null>;
    }
  | undefined
>(undefined);

export const AppMenuContextProvider = AppMenuContext.Provider;

export const useAppMenuContext = () => {
  const context = useContext(AppMenuContext);

  if (!context) {
    throw new Error("AppMenuContext is not provided");
  }

  return context;
};
